import React from 'react'
import {useHistory} from "react-router-dom";
import {useSelector, useDispatch} from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CButton,
  CSidebarNavItem,
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import "../css/CustomStyles.css"

// sidebar nav config
import navigation from './_nav'
import Role from "../utils/Role";

const TheSidebar = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow)

  return (
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({type: 'set', sidebarShow: val})}
    >
      <CSidebarBrand className="d-md-down-none" to="/" style={{backgroundColor: 'white'}}>
        {/*<CIcon*/}
        {/*  className="c-sidebar-brand-full"*/}
        {/*  name="logo-negative"*/}
        {/*  height={35}*/}
        {/*/>*/}
        {/*<CIcon*/}
        {/*  className="c-sidebar-brand-minimized"*/}
        {/*  name="sygnet"*/}
        {/*  height={35}*/}
        {/*/>*/}
        {/*asdf*/}
        {/*<b style={{*/}
        {/*  fontSize : "1.2em"*/}
        {/*}}>*/}
        <img
          className="c-sidebar-brand-minimized"
          height={35}
          src={require("../assets/icons/main-logo.svg")}/>

        <img
          className="c-sidebar-brand-full"
          height={35}
          style={{
            padding : 5
          }}
          src={require("../assets/icons/long-logo.svg")}/>
        {/*Learning Dashboard*/}
        {/*</b>*/}
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigation}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle
          }}
        />
        {/*<CButton color="danger" onClick={()=>{*/}
        {/*  sessionStorage.removeItem("token");*/}
        {/*  localStorage.removeItem("token");*/}
        {/*  history.push("/login");*/}
        {/*}}>Logout</CButton>*/}
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none"/>
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
